import {
  QrLoginStatusResponseStatusEnum,
  QrLoginWaitApprovedResponseStatusEnum,
  QrLoginWaitPendingResponseStatusEnum
} from 'src/api/main'

export const QR_PANEL_STATUS = {
  STARTING: 'starting',
  ACTIVE: 'active',
  SCANNED: 'scanned',
  EXPIRED: 'expired',
  DENIED: 'denied',
  CANCELED: 'canceled',
  APPROVED: 'approved',
  ERROR: 'error'
} as const

export type QrPanelStatus =
  (typeof QR_PANEL_STATUS)[keyof typeof QR_PANEL_STATUS]

/** Wait-poll statuses returned by the API, sourced from the generated enums. */
export const QR_LOGIN_WAIT_STATUS = {
  PENDING: QrLoginWaitPendingResponseStatusEnum.PENDING,
  SCANNED: QrLoginWaitPendingResponseStatusEnum.SCANNED,
  APPROVED: QrLoginWaitApprovedResponseStatusEnum.APPROVED,
  DENIED: QrLoginStatusResponseStatusEnum.DENIED,
  EXPIRED: QrLoginStatusResponseStatusEnum.EXPIRED,
  CANCELED: QrLoginStatusResponseStatusEnum.CANCELED
} as const

export type QrLoginWaitStatus =
  (typeof QR_LOGIN_WAIT_STATUS)[keyof typeof QR_LOGIN_WAIT_STATUS]

/**
 * antd `QRCode` `status` prop values — these are render states of the QR
 * widget, not API statuses, so they live in their own object rather than as
 * inline magic strings.
 */
export const QR_CODE_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  LOADING: 'loading',
  SCANNED: 'scanned'
} as const

export type QrCodeStatus = (typeof QR_CODE_STATUS)[keyof typeof QR_CODE_STATUS]

export const MAX_AUTO_RENEWS = 3
export const FULL_AUTO_RENEW_DELAY_MS = 1000
export const COMPACT_AUTO_RENEW_DELAY_MS = 3500
